import { Rule } from '@webkit/validation/value';

export const range = (min: number, max: number, error?: string) =>
    ({
        id: 'range',
        validator: value => {
            if (value === undefined || value === null || value === '') return true;

            const parsed = parseFloat(value.toString().replace(/[^0-9.-]+/g, ''));
            return isNaN(parsed) || (parsed >= min && parsed <= max);
        },
        error: () => error || `Must be between ${min} and ${max}`,
    } as Rule<number | string>);
